import { addDays, isoDayOfWeek } from '@lidotel/shared';

interface Point {
  fecha: string;
  occPct: number | null; // 0..1
}

const DOW = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

/** Occupancy heatmap: day-of-week × week (chart #6). Pure CSS grid. */
export function OccupancyHeatmap({ points }: { points: Point[] }) {
  // Group by week (Monday) → 7 cells per week.
  const weeks = new Map<string, (number | null)[]>();
  for (const p of points) {
    const dow = isoDayOfWeek(p.fecha); // 1..7
    const monday = addDays(p.fecha, -(dow - 1));
    const row = weeks.get(monday) ?? new Array<number | null>(7).fill(null);
    row[dow - 1] = p.occPct;
    weeks.set(monday, row);
  }
  const rows = [...weeks.entries()].sort(([a], [b]) => a.localeCompare(b));

  if (rows.length === 0) return <p className="text-sm text-slate-500">Sin datos para el rango.</p>;

  return (
    <div className="overflow-x-auto">
      <table className="border-separate" style={{ borderSpacing: 3 }}>
        <thead>
          <tr>
            <th className="pr-2 text-right text-[10px] text-slate-500"></th>
            {DOW.map((d) => (
              <th key={d} className="text-[10px] font-normal text-slate-500">
                {d}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([monday, cells]) => (
            <tr key={monday}>
              <td className="pr-2 text-right text-[10px] text-slate-500">{monday.slice(5)}</td>
              {cells.map((occ, i) => (
                <td key={i}>
                  <div
                    title={occ == null ? '—' : `${(occ * 100).toFixed(1)}%`}
                    className="h-5 w-6 rounded"
                    style={{
                      background: occ == null ? '#1e293b' : `rgba(34,197,94,${0.12 + occ * 0.88})`,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
